/**
 * _modifiers.ts — Grupos de modificadores demo para productos de restaurante.
 *
 * IDs estables para mocks (no usar newModifierGroupId en export).
 */
import type { ModifierGroup } from "@/types";

/** Extras típicos de hamburguesa — demo tienda virtual. */
export const HAMBURGUESA_MODIFIERS: ModifierGroup[] = [
  {
    id: "mod_hamb_papas",
    label: "¿Agregar papas?",
    tipoSeleccion: "single",
    required: false,
    min: 0,
    max: 1,
    opciones: [
      { id: "mop_sin_papas", label: "Sin papas" },
      { id: "mop_papas", label: "Papas fritas", precioExtra: 4000 },
    ],
  },
  {
    id: "mod_hamb_extras",
    label: "Extras",
    tipoSeleccion: "multiple",
    min: 0,
    max: 4,
    opciones: [
      { id: "mop_queso", label: "Queso extra", precioExtra: 2000 },
      { id: "mop_tocineta", label: "Tocineta", precioExtra: 3000 },
      { id: "mop_carne", label: "Carne extra", precioExtra: 7000 },
    ],
  },
  {
    id: "mod_hamb_quitar",
    label: "¿Quitar algo?",
    tipoSeleccion: "multiple",
    min: 0,
    max: 4,
    opciones: [
      { id: "mop_sin_cebolla", label: "Sin cebolla" },
      { id: "mop_sin_tomate", label: "Sin tomate" },
      { id: "mop_sin_lechuga", label: "Sin lechuga" },
      { id: "mop_sin_salsas", label: "Sin salsas" },
    ],
  },
  {
    id: "mod_hamb_cubiertos",
    label: "¿Cubiertos?",
    tipoSeleccion: "boolean",
    required: false,
    min: 0,
    max: 1,
    opciones: [
      { id: "mop_cub_si", label: "Sí, con cubiertos" },
      { id: "mop_cub_no", label: "No, sin cubiertos" },
    ],
  },
];

/** Menú del día — demo almuerzo ejecutivo. */
export const ALMUERZO_MODIFIERS: ModifierGroup[] = [
  {
    id: "mod_alm_sopa",
    label: "Sopa",
    tipoSeleccion: "single",
    required: true,
    min: 1,
    max: 1,
    opciones: [
      { id: "mop_mondongo", label: "Mondongo" },
      { id: "mop_ajiaco", label: "Ajiaco", precioExtra: 2000 },
      { id: "mop_sin_sopa", label: "Sin sopa" },
    ],
  },
  {
    id: "mod_alm_principio",
    label: "Principio",
    tipoSeleccion: "single",
    required: true,
    min: 1,
    max: 1,
    opciones: [
      { id: "mop_frijoles", label: "Frijoles" },
      { id: "mop_lentejas", label: "Lentejas" },
      { id: "mop_arroz", label: "Arroz" },
    ],
  },
  {
    id: "mod_alm_proteina",
    label: "Proteína",
    tipoSeleccion: "single",
    required: true,
    min: 1,
    max: 1,
    opciones: [
      { id: "mop_carne", label: "Carne asada" },
      { id: "mop_pollo", label: "Pechuga a la plancha" },
      { id: "mop_cerdo", label: "Lomo de cerdo", precioExtra: 2000 },
    ],
  },
  {
    id: "mod_alm_bebida",
    label: "Bebida",
    tipoSeleccion: "single",
    required: true,
    min: 1,
    max: 1,
    opciones: [
      { id: "mop_agua", label: "Agua" },
      { id: "mop_limonada", label: "Limonada", precioExtra: 1000 },
      { id: "mop_gaseosa", label: "Gaseosa" },
    ],
  },
  {
    id: "mod_alm_cubiertos",
    label: "¿Cubiertos?",
    tipoSeleccion: "boolean",
    required: false,
    min: 0,
    max: 1,
    opciones: [
      { id: "mop_cub_si", label: "Sí" },
      { id: "mop_cub_no", label: "No" },
    ],
  },
];
